// Supporting Document limits for Raise Service Request (v1.3 ticket 07, RCMC-01).
//
// The browser half of the check: size and type, before anything is sent, so a refused file is reported on
// the upload control at once. The server repeats both and also checks the content against the extension
// (UserPortal/supporting_document.py, same limits, same messages); keep the two in step.
//   - at most 2 MB (2,097,152 bytes)                              owner rulings Q15/Q20
//   - pdf jpg jpeg png csv docx doc txt xlsx, by extension, any case
// Messages: owner ruling Q28 (imperative, naming the file).

export const SUPPORTING_DOCUMENT_TYPES = ["pdf", "jpg", "jpeg", "png", "csv", "docx", "doc", "txt", "xlsx"];

/** The file input's `accept` list: the picker offers only these */
export const SUPPORTING_DOCUMENT_ACCEPT = SUPPORTING_DOCUMENT_TYPES.map((type) => `.${type}`).join(",");

const MEGABYTE = 1024 * 1024;
export const SUPPORTING_DOCUMENT_MAX_BYTES = 2 * MEGABYTE; // 2,097,152

const ACCEPTED_LIST = "PDF, JPG, PNG, CSV, DOC, DOCX, TXT or XLSX";

/** The limits as the form states them, below the upload control */
export const SUPPORTING_DOCUMENT_HINT = `Up to 2 MB. ${ACCEPTED_LIST}.`;

/** "pdf" for "Scan.PDF"; "" when there is none. Leading dots don't count (as Python's os.path.splitext). */
function extensionOf(name) {
  const base = name.replace(/^\.+/, "");
  const dot = base.lastIndexOf(".");
  return dot === -1 ? "" : base.slice(dot + 1).toLowerCase();
}

/** Size in MB to one decimal, rounded up, so anything over the limit never reads as "2.0 MB" */
function megabytes(size) {
  return (Math.ceil((size * 10) / MEGABYTE) / 10).toFixed(1);
}

/**
 * @param {File} file  the file the picker handed over
 * @returns {string|null} why it cannot be attached, or null when it can
 */
export function supportingDocumentError(file) {
  if (!SUPPORTING_DOCUMENT_TYPES.includes(extensionOf(file.name))) {
    return `Choose a ${ACCEPTED_LIST} file — ${file.name} is not one of these.`;
  }
  if (file.size > SUPPORTING_DOCUMENT_MAX_BYTES) {
    return `Choose a file of 2 MB or less — ${file.name} is ${megabytes(file.size)} MB.`;
  }
  return null;
}
